import { createBrowserRouter } from 'react-router-dom';
import InvalidLink from './InvalidLink';

const router = createBrowserRouter([
  {
    path: '/offer/:token',
    lazy: () => import('../upsell/OfferLanding').then((m) => ({ Component: m.default })),
  },
  {
    path: '/pre-upsell/:token',
    lazy: () => import('../upsell/PreUpsellCallback').then((m) => ({ Component: m.default })),
  },
  {
    path: '/unsubscribe/:token',
    lazy: () => import('../upsell/Unsubscribe').then((m) => ({ Component: m.default })),
  },
  {
    path: '*',
    element: <InvalidLink />,
  },
]);

export default router;
